import type { AccessPointLayer } from '@/lib/commerce';
import type { MapSource } from '@/lib/mapping-api';

export const ROUTE_PRICING_ACCESS_POINT_PURPOSES = ['quote_estimate', 'business_quote_estimate'] as const;

export interface ZoneInfrastructureBinding {
  accessPointLayer: AccessPointLayer;
  mapSource: MapSource;
  fiberMapSource?: MapSource | null;
}
